<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicleId)">
                                        <label>Vehicle</label>
                                        <select v-model="trip.vehicleId" name="vehicleId" required class="form-control">
                                            <option disabled>Select Vehicle</option>
                                            <option v-for="(item,index) in vehicle_no" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="vehicleId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Vehicle is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.deviceId)">
                                        <label>Device</label>
                                        <select v-model="trip.deviceId" required name="deviceId" class="form-control">
                                            <option disabled>Device</option>
                                            <option v-for="(item,index) in device_name" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="deviceId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Device is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverId)">
                                        <label>Driver</label>
                                        <select required v-model="trip.driverId" name="driverId" class="form-control">
                                            <option disabled>Driver</option>
                                            <option v-for="(item,index) in driver_name" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="driverId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Driver is a required field</div>
                                        </field-messages>
                                        
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <label>Scheduled Date</label>
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleDate)">
                                            <date-picker  id="scheduleDate" required v-model="trip.scheduleDate" lang="en" name="scheduleDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                            <field-messages name="scheduleDate" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Schedule Date is a required field</div>
                                                <div slot="pattern">Schedule Date is invalid</div>
                                            </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-2">
                                    <label>Scheduled Time</label>
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduledTime)">
                                            <vue-timepicker name="scheduledTime" required v-model="scheduledTime" style="width: 271px"></vue-timepicker>
                                            <field-messages name="scheduledTime" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Schedule Time is a required field</div>
                                            </field-messages>
                                    </validate>
                                </div>                                
                            </div>
                            <div class="col-sm-12">
                               <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.routeId)">
                                        <label>Route Name</label>
                                        <select v-model="trip.routeId" required name="routeId" class="form-control" @change="getSites">
                                            <option disabled>Select Route</option>
                                            <option v-for="(item,index) in route_name" :key="index" v-bind:value="item._id" v-bind:sourceSite="item.startSite" v-bind:destinationSite="item.endSite">
                                                {{item.name}}
                                            </option>
                                        </select>
                                        <field-messages name="routeId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Route is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regionManager)">
                                        <label>G.A Head</label>
                                        <select v-model="trip.regionManager" required name="regionManager" class="form-control">
                                            <option selected disabled>Select G.A Head</option>
                                            <option v-for="(item,index) in region_managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">G.A Head is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.journeyManager)">
                                        <label>Journey Manager</label>
                                        <select v-model="trip.journeyManager" required name="journeyManager" class="form-control">
                                            <option value="" disabled>Select Jouney Manager</option>
                                            <option v-for="(item,index) in journey_managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="journeyManager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Journey Manager is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                        </vue-form> 
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Trip' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="createTrip" :disabled="!(formstate.$valid)">Add Trip</button>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formService, eventBus , tripService } from '../../../services'
import { EVENTS } from '../../../config'
import Config, { USER_ROLES } from '../../../config';
import { mapState } from 'vuex'
import 'vue2-timepicker/dist/VueTimepicker.css'
import axios from 'axios'

export default {
    name: 'TripCreate',
    data () {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            region_list : {},
            region_managers : {},
            start_site : {},
            end_site :{},
            vehicle_no : {},
            route_name : {},
            driver_name :{},
            device_name :{},
            journey_managers: {},
            scheduledTime:'',
            projectFormat: 'hh:mm',
            status: 'scheduled',
            sourceSite: '',
            destinationSite:'',
            device : {
               status : 'active'
            },
            trip : {
            },
        }
    },
    mounted: function() {
        //this.getRegionList()
        this.getRegionManager()
        this.getDriverName()
        this.getDeviceName()
        this.getRouteName()
        this.getVehicle()
        this.getJourneyManager()
    },
    methods: {
        fieldClassName: formService.fieldClassName,
        createTrip () {
            this.loading = true;
            this.trip = {
                ...this.trip,
                status : this.status,
                endSite : this.destinationSite,
                startSite : this.sourceSite,
                scheduleTime : this.scheduledTime

            }
            return tripService.addTrip(this.trip)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('Trip added!', 'Success!')
                this.$router.push('/trip')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('trip Add failed! Try Again', 'Error!')
                if(error.data.message == "dvgdxfv"){
                    this.$snotify.success('Trip added!', 'Success!')
                    this.$router.push('/trip')
                }
            })
        },
        getRegionManager() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 2;
            let regionManagerList = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionManagerList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.region_managers = regionManagerList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region Manager.requestFunction-error:', error)
                    this.$snotify.error('Get region manager list failed', 'Error!')
                })
        },
        getJourneyManager(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 3;
            let journeyManagerList = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        journeyManagerList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.journey_managers = journeyManagerList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('journey Manager.requestFunction-error:', error)
                    this.$snotify.error('Get journey manager list failed', 'Error!')
                })
        },
        getSites(e){
            this.sourceSite =  e.target.options[e.target.selectedIndex].getAttribute('sourceSite');
            this.destinationSite = e.target.options[e.target.selectedIndex].getAttribute('destinationSite');
        },
        getVehicle(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            if (this.user.roleName == "GA Head"){
                params.regionRegionManager = this.user._id
            }
            // if (this.user.roleName == "Journey Manager"){
            //         params.regionJourneyManager = this.user._id
               
            // }
            //params.roleRank = 4;
            let vehicleList = [];
            this.$vehicleDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        vehicleList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.regNo,
                                
                            }
                        })
                       
                    }
                    this.vehicle_no = vehicleList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('vehicle.requestFunction-error:', error)
                    this.$snotify.error('Get vehicle list failed', 'Error!')
                })
        },
        getDriverName(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let driverList= []
            if(this.user.roleName == 'Journey Manager'){
            axios.get(`${Config.serverURI}/regions-drivers?manager=${this.user._id}`)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.drivers && res.data.drivers) {
                        driverList =  res.data.drivers.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.driverName,
                                
                            }
                        })
                       
                    }
                   
                    this.driver_name = driverList;
                    
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('driver.requestFunction-error:', error)
                    this.$snotify.error('Get driver list failed', 'Error!')
                })
            }else{
            
            this.$driverDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        driverList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.driverName,
                                
                            }
                        })
                       
                    }
                    this.driver_name = driverList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('driver.requestFunction-error:', error)
                    this.$snotify.error('Get driver list failed', 'Error!')
                })
        
            }
        },
        getDeviceName(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            //params.roleRank = 4;
            let deviceList = [];
            this.$deviceDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        deviceList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.deviceId,
                                
                            }
                        })
                       
                    }
                    this.device_name = deviceList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('device.requestFunction-error:', error)
                    this.$snotify.error('Get device list failed', 'Error!')
                })
        },
        getRouteName(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let routeList = [];
            this.$triprouteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        routeList =  res.data.docs;
                       
                    }
                    this.route_name = routeList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('triproute.requestFunction-error:', error)
                    this.$snotify.error('Get route list failed', 'Error!')
                })
        },
        
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        }
        
    },
    computed : {
        ...mapState({
            user : state => state.auth.user,
        })
    }
}
</script>
<style scoped>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .mt {
        margin-top: 7px;
    }
    .gradientbt{
        background: #0F6940;
        color: white 
    }
    .box-body {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
    }
</style>


// WEBPACK FOOTER //
// TripCreate.vue?a7309e08